import {
  Box,
  List,
  ListItemButton as MuiListItemButton,
  ListProps,
  styled,
} from '@mui/material';

const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color, theme }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: color,
  marginLeft: theme.spacing(1),
}));

const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  fontSize: theme.fontSizes.regular,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '150%',
  color: theme.palette.grey[500],

  '&.Mui-selected': {
    backgroundColor: theme.palette.grey[100],
    border: 'none',

    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
}));

export type TabsMenuProps<T extends string> = {
  tabs: Array<{ label: string; id: T; dotColor?: string }>;
  selectedTab: T;
  menuProps?: ListProps;
  onTabChange: (tab: T) => void;
};

const VerticalTabsMenu = <T extends string>({
  tabs,
  selectedTab,
  menuProps,
  onTabChange,
}: TabsMenuProps<T>) => (
  <List disablePadding {...menuProps}>
    {tabs.map((tab) => (
      <ListItemButton
        key={tab.id}
        selected={selectedTab === tab.id}
        onClick={() => {
          onTabChange(tab.id);
        }}
      >
        {tab.label}
        {tab.dotColor ? <Dot color={tab.dotColor} /> : null}
      </ListItemButton>
    ))}
  </List>
);

export default VerticalTabsMenu;
